import { cn } from '../../lib/cn';
import { initials } from '../../lib/format';

// Muted tints (defined per theme in index.css) so people are easy to tell apart without shouting.
const tints = [
  'bg-[var(--tint-1-bg)] text-[var(--tint-1-fg)]',
  'bg-[var(--tint-2-bg)] text-[var(--tint-2-fg)]',
  'bg-[var(--tint-3-bg)] text-[var(--tint-3-fg)]',
  'bg-[var(--tint-4-bg)] text-[var(--tint-4-fg)]',
  'bg-[var(--tint-5-bg)] text-[var(--tint-5-fg)]',
  'bg-[var(--tint-6-bg)] text-[var(--tint-6-fg)]',
];

function hash(value: string): number {
  let h = 0;
  for (let i = 0; i < value.length; i++) h = (h * 31 + value.charCodeAt(i)) | 0;
  return Math.abs(h);
}

export function Avatar({ name, seed, size = 'md', className }: { name: string; seed?: string; size?: 'sm' | 'md' | 'lg'; className?: string }) {
  const dims = size === 'sm' ? 'size-7 text-[0.6875rem]' : size === 'lg' ? 'size-12 text-body' : 'size-9 text-label';
  return (
    <span
      aria-hidden
      className={cn(
        'inline-grid shrink-0 select-none place-items-center rounded-full font-semibold tracking-wide',
        dims,
        tints[hash(seed ?? name) % tints.length],
        className,
      )}
    >
      {initials(name)}
    </span>
  );
}
